var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyPairBase = void 0;
class KeyPairBase {}
exports.KeyPairBase = KeyPairBase;
export default exports;